import { render, staticRenderFns } from "./DistributorImports.vue?vue&type=template&id=24e17189"
import script from "./DistributorImports.vue?vue&type=script&lang=js"
export * from "./DistributorImports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports